import { useTranslation } from "react-i18next";
import { useState } from "react";
import Api from "../../../../../Api";
import TeambookTextForm from "../../../../default_components/TeambookTextForm";
import { shallow } from "zustand/shallow";
import { useNotificationStore } from "../../../../../stores/notificationStore";
import TeambookDialog from "../../../../default_components/TeambookDialog";
import PropTypes from "prop-types";

export default function EditPayroll({ getProjects, open, setOpen, selectedTimeOff }) {
  const { t } = useTranslation();
  const [setInAppNotification] = useNotificationStore((state) => [state.setInAppNotification], shallow);
  const [name, setName] = useState(selectedTimeOff.name);
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorField, setErrorField] = useState(null);

  const handleSubmit = () => {
    Api.PayrollItems.update(selectedTimeOff.id, name)
      .then((response) => {
        handleClose();
        setErrorMessage(null);
        setInAppNotification(t("notifications.settings.timeoff_holidays.time_off.edit"));
      })
      .catch((error) => analyzeCreationError(error));
  };

  const handleClose = () => {
    getProjects();

    setOpen(false);
    setErrorMessage(null);
    setErrorField(null);
  };

  const analyzeCreationError = (error) => {
    setErrorMessage(error.response.data.error.message);
    setErrorField(error.response.data.error.field);
  };

  const closeErrorMessage = () => {
    setErrorMessage(null);
    setErrorField(null);
  };

  return (
    <TeambookDialog
      open={open}
      onClose={handleClose}
      title={t("settings.tasks.edit_payroll")}
      withCloseButton
      content={
        <div>
          <div style={{display: "flex", justifyContent: "space-between"}}>
            <TeambookTextForm
              id={"nameTimeOff"}
              fieldName={t("settings.time_off.to_name")}
              onChange={(text) => setName(text.length > 0 ? text[0].toUpperCase() + text.slice(1) : "")}
              type={"text"}
              fieldValue={name}
              width={"100%"}
              errorField={errorField}
              errorMessage={errorMessage}
              field={"name"}
              closeErrorMessage={closeErrorMessage}
            />
          </div>
        </div>
      }
      actionButtons={[
        {
          text: t("save"),
          onClick: handleSubmit,
          id: "saveEditTimeOffButton",
        },
      ]}
    />
  );
}

EditPayroll.propTypes = {
  getProjects: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  selectedTimeOff: PropTypes.object.isRequired,
}
